import React from "react";
import { Col, Row } from "react-bootstrap";
import styles from "../../styles/PostCreateEditForm.module.css";
// import { Button as ManButton } from "@mantine/core";
import { useParams } from "react-router-dom";
import { VIMEO_BASE_URL } from "../../utils/config";
import TopBox from "../../components/TopBox";

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const params = useParams();
  // const [close, setClose] = useState(true) 

  return (
    <div>
      <div className="mx-md-5">
        <TopBox title="How it Works" />
      </div>
      <Row>
        <Col className={`${styles.Back} mt-3`} md={{ span: 8, offset: 2 }}>
          <div className={styles.TutorialLayout}>
            <div className={styles.TutorialContentColumn}>
              <h5>{params?.title}</h5>
            </div>

            <div className={styles.TutorialVideoColumn}>
              <iframe
                className={styles.TutorialVideo}
                src={`${VIMEO_BASE_URL}${params?.video_id}`} // Replace with your dummy YouTube link
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </Col>
      </Row>
      {/* <Row> */}
      {/* <Col className="text-center d-lg-none"> */}
        {/* <p  */}
        {/* // className={` ${styles.Watch} `}>Click to open page</p> */}
      {/* {close ? (
        <p onClick={() => setClose(false)}
        className={` ${styles.Watch} `}>Click to open page</p>
      ): ("")} */}
      {/* </Col> */}
      {/* </Row> */}
    </div>
  );
}
